/*
  WLAM – gói quà tặng trong giỏ (xem snippets/wl-wrap.liquid).
  Bấm "Thêm" để thêm 1 Hộp quà / Túi quà vào giỏ; bấm lại để bỏ ra.
*/
import { Cart } from './cart.js';
import { events } from './theme.js';

const routes = window.Atelier?.routes || {};
let busy = false;

class WlWrap extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = async (e) => {
    const btn = e.target.closest('[data-v]');
    if (!btn || busy) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const cart = btn.dataset.key
        ? await Cart.update({ updates: { [btn.dataset.key]: 0 } })
        : await Cart.post(`${routes.cart_add_url}.js`, { items: [{ id: Number(btn.dataset.v), quantity: 1 }] });
      if (cart) events.emit('cart:updated', { cart });
    } catch {
    } finally {
      busy = false;
      btn.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('wl-wrap')) customElements.define('wl-wrap', WlWrap);
